import { render } from "./UsageRecords.vue?vue&type=template&id=4dc8926b&scoped=true"
import script from "./UsageRecords.vue?vue&type=script&lang=js"
export * from "./UsageRecords.vue?vue&type=script&lang=js"

import "./UsageRecords.vue?vue&type=style&index=0&id=4dc8926b&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc8926b"]])

export default __exports__